<template>
  <div class="content">
    <progress-bar :percent="20" />

    <div class="center">
      <CrossSvg class="cross" />
      <div class="text">
        This SolShare is not supported for over-the-air software update.
      </div>
      <div class="note">
        Please contact Allume Technical support for assistance before continuing
        commissioning.
      </div>
    </div>

    <yellow-button class="contact" to="/contact">
      CONTACT ALLUME
    </yellow-button>

    <back-button />
  </div>
</template>

<script>
import CrossSvg from "../assets/svg/cross.svg";

export default {
  name: "SoftwareUpdateUnsupported",
  components: {
    CrossSvg,
  },
};
</script>

<style lang="less" scoped>
.content {
  .cross {
    margin-top: 64px;
    margin-bottom: 22px;
  }

  .center {
    text-align: center;

    .text {
      font-size: 25px;
      line-height: 29px;
      color: #005149;
      font-family: "Helvetica Light", sans-serif;
      width: 272px;
      margin: 0 auto 24px auto;
    }

    .note {
      font-size: 17px;
      line-height: 22px;
      font-family: "Helvetica Light", sans-serif;
      width: 272px;
      margin: 0 auto 47px auto;
    }
  }

  .contact {
    margin-bottom: 92px;
  }
}
</style>
